import { createClient } from "graphql-ws";
import type {
  AuthMiddlewareOpts,
  QueryPayload,
  RelayObservable,
  UrlMiddlewareOpts,
} from "react-relay-network-modern";
import { authMiddleware, RelayNetworkLayer, urlMiddleware } from "react-relay-network-modern";
import { Observable } from "relay-runtime";

import { config } from "shared/data";

import { invalidGatewayToken } from "./invalid-gateway-token";
import { persistedQueries } from "./persisted-queries";

export type NetworkOptions = {
  authOptions: AuthMiddlewareOpts;
  urlOptions: UrlMiddlewareOpts;
};

export const network = ({ authOptions, urlOptions }: NetworkOptions) => {
  const url = new URL(urlOptions.url as string);
  url.protocol = url.protocol === "https:" ? "wss:" : "ws:";
  url.searchParams.set("apikey", config.graphql.contentService.apiKey);
  const wsClient = createClient({
    url: url.toString(),
  });

  return new RelayNetworkLayer(
    [
      urlMiddleware({
        credentials: "include",
        ...urlOptions,
      }),
      authMiddleware({
        ...authOptions,
      }),
      persistedQueries({ useGETForHashedQueries: true }),
      invalidGatewayToken(),
    ],
    {
      subscribeFn(operation, variables) {
        return Observable.create(sink =>
          wsClient.subscribe(
            {
              operationName: operation.name,
              query: operation.text ?? "",
              variables,
            },
            sink,
          ),
        ) as unknown as RelayObservable<QueryPayload>;
      },
    },
  );
};
